import $ from "jquery";

import events from "./events";

const retainVideoAutoplayParam = "?autoplay=1";

function handleSubmit($form) {
    events.sendConversion("_a--CIzTlZMCEMGjhrIB", "AW-373395905"); // AdWords: Demo form submit
    if (window.fbq) {
        window.fbq("track", "Demo Request");
    }
    if (window.lintrk) {
        window.lintrk("track", { conversion_id: 4527012 });
    }

    const data = {};
    $form.serializeArray().forEach((x) => {
        data[x.name] = x.value;
    });
    data.name = `${data.firstname} ${data.lastname}`;
    data.page = window.location.pathname;

    $.ajax({
        type: "POST",
        url: "/api/v1/pages/employer/lead/",
        contentType: "application/json",
        data: JSON.stringify(data),
    });
}
window.onDemoSubmit = handleSubmit;

function showRetainVideoModal(e) {
    e.preventDefault();
    const $modal = $("#sohp2-retain-video-section__video-modal");
    if ($modal.length === 0) {
        return;
    }
    const $iframe = $modal.find("iframe");
    const vidsrc = $iframe.attr("src");
    if (!vidsrc.endsWith(retainVideoAutoplayParam)) {
        $iframe.attr("src", `${vidsrc}${retainVideoAutoplayParam}`);
    }
    $modal.modal({
        fadeDuration: 350,
        fadeDelay: 0,
    });
}

function stopRetainVideoModalOnClose() {
    const $modal = $("#sohp2-retain-video-section__video-modal");
    if ($modal.length === 0) {
        return;
    }
    $modal.on($.modal.AFTER_CLOSE, () => {
        const $iframe = $modal.find("iframe");
        const vidsrc = $iframe.attr("src");
        if (vidsrc.endsWith(retainVideoAutoplayParam)) {
            $iframe.attr("src", vidsrc.slice(0, -1 * retainVideoAutoplayParam.length));
        }
    });
}

export default function initHomepage() {
    $(".sohp2-retain-video-section__video-link").click(showRetainVideoModal);
    stopRetainVideoModalOnClose();

    const $reviews = $("#candidate-workstep-reviews");
    if ($reviews.length) {
        $reviews.slick({
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: 12000,
        });
    }
}
